import { Component, OnInit, OnDestroy, SimpleChanges, OnChanges, Input } from '@angular/core';
import { TableService } from '../../services/integrated/table.service';
import { ActivatedRoute } from '@angular/router';
import { Globals } from '../../globals';

@Component({
  selector: 'app-infocart',
  templateUrl: './infocart.component.html',
  styleUrls: ['./infocart.component.css',]
})
export class InfocartComponent implements OnInit, OnChanges, OnDestroy {
  @Input('id') id:number
  private cols = [

    { field: 'id', show: false },
    { title: 'FEcart.code', field: 'code', show: true, filter: true },
    { title: 'FEcart.day_start', field: 'day_start', show: true, filter: true },
    { title: 'FEcart.price_total', field: 'price_total', show: true, filter: true },
    { title: 'FEcart.delivery_status', field: 'delivery_status', show: true, filter: true },
  ];
  public cwstable = new TableService();
  public connect;
  public token: any = {
    followcard: "api/followcard"
  }
  constructor(public globals: Globals, private routerAct: ActivatedRoute, ) {
    this.connect = this.globals.result.subscribe((response: any) => {
      switch (response['token']) {
        case 'followcard':
          this.cwstable._concat(response.data, true);
          break;
        default:
          break;
      }
    })
  }

  ngOnInit() {
    this.cwstable._ini({ cols: this.cols, data: [], keyword: 'content' });

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.id && this.id != 0) {
      this.globals.send({ path: this.token.followcard, token: 'followcard', params: { id: this.id } });
    }

  }
  ngOnDestroy() {
    this.connect.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/frontend/infocart/infocart.component.ts